export default __webpack_public_path__ + "static/media/canva.f1bf26da.svg";